const check = () => {
  return (
    <svg height="24" viewBox="0 -960 960 960" width="24" fill="white">
      <path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" />
    </svg>
  );
};

export default check;
